module.exports = __webpack_public_path__ + "img/google-play-en.e3ea015c.svg";